import React from 'react'

// Import all your existing icons
import HouseSvg from '../assets/icons/house.svg?react'
import HouseFillSvg from '../assets/icons/house.fill.svg?react'
import PersonSvg from '../assets/icons/person.svg?react'
import PersonFillSvg from '../assets/icons/person.fill.svg?react'
import PersonCircleSvg from '../assets/icons/person.circle.svg?react'
import PersonCircleFillSvg from '../assets/icons/person.circle.fill.svg?react'
import VideoSvg from '../assets/icons/video.svg?react'
import VideoFillSvg from '../assets/icons/video.fill.svg?react'
import FilmSvg from '../assets/icons/film.svg?react'
import FilmFillSvg from '../assets/icons/film.fill.svg?react'
import BellSvg from '../assets/icons/bell.svg?react'
import BellBadgeSvg from '../assets/icons/bell.badge.svg?react'
import GearSvg from '../assets/icons/gear.svg?react'
import PlusSvg from '../assets/icons/plus.svg?react'
import PlaySquareSvg from '../assets/icons/play.square.svg?react'
import ArrowLeftSvg from '../assets/icons/arrow.left.svg?react'
import ChevronRightSvg from '../assets/icons/chevron.right.svg?react'
import EllipsisSvg from '../assets/icons/ellipsis.svg?react'
import EllipsisVerticalSvg from '../assets/icons/ellipsis.vertical.svg?react'
import CheckmarkSvg from '../assets/icons/checkmark.svg?react'
import LogoutSvg from '../assets/icons/logout.svg?react'
import AppearanceSvg from '../assets/icons/appearance.svg?react'
import TranslateSvg from '../assets/icons/translate.svg?react'
import ThumbsUpSvg from '../assets/icons/hand.thumbsup.svg?react'
import ThumbsUpFillSvg from '../assets/icons/hand.thumbsup.fill.svg?react'
import ThumbsDownSvg from '../assets/icons/hand.thumbsdown.svg?react'
import ThumbsDownFillSvg from '../assets/icons/hand.thumbsdown.fill.svg?react'
import SquareArrowUpSvg from '../assets/icons/square.and.arrow.up.svg?react'
import SquareArrowUpFillSvg from '../assets/icons/square.and.arrow.up.fill.svg?react'
import SquarePencilSvg from '../assets/icons/square.and.pencil.svg?react'
import ChartPieSvg from '../assets/icons/chart.pie.svg?react'
import ChartPieFillSvg from '../assets/icons/chart.pie.fill.svg?react'
import TrophySvg from '../assets/icons/trophy.svg?react'
import TrophyFillSvg from '../assets/icons/trophy.fill.svg?react'
import ShareplaySvg from '../assets/icons/shareplay.svg?react'
import Person2Svg from '../assets/icons/person.2.svg?react'
import Person2FillSvg from '../assets/icons/person.2.fill.svg?react'
import Person2BadgePlusSvg from '../assets/icons/person.2.badge.plus.svg?react'
import MusicNoteTvSvg from '../assets/icons/music.note.tv.svg?react'
import MusicNoteTvFillSvg from '../assets/icons/music.note.tv.fill.svg?react'
import MusicNoteHouseSvg from '../assets/icons/music.note.house.svg?react'
import TerminalSvg from '../assets/icons/apple.terminal.svg?react'
import TerminalFillSvg from '../assets/icons/apple.terminal.fill.svg?react'
import RichtextPageSvg from '../assets/icons/richtext.page.svg?react'
import RichtextPageFillSvg from '../assets/icons/richtext.page.fill.svg?react'
import ClockRotateSvg from '../assets/icons/clock.arrow.trianglehead.counterclockwise.rotate.90.svg?react'
import SliderHorizontalSvg from '../assets/icons/slider.horizontal.3.svg?react'
import RectanglePencilSvg from '../assets/icons/rectangle.and.pencil.and.ellipsis.svg?react'

// Icon registry - map icon names to components
const icons = {
  // Home/Navigation
  home: HouseSvg,
  house: HouseSvg, // alias
  'home-fill': HouseFillSvg,
  'house.fill': HouseFillSvg, // alias
  'arrow-left': ArrowLeftSvg,
  'arrow.left': ArrowLeftSvg, // alias
  'chevron-right': ChevronRightSvg,
  'chevron.right': ChevronRightSvg, // alias

  // User/Profile
  person: PersonSvg,
  'person-fill': PersonFillSvg,
  'person.fill': PersonFillSvg, // alias
  'person-circle': PersonCircleSvg,
  'person-circle-fill': PersonCircleFillSvg,
  'person-2': Person2Svg,
  'person-2-fill': Person2FillSvg,
  'person-2-badge-plus': Person2BadgePlusSvg,

  // Video/Media
  video: VideoSvg,
  'video-fill': VideoFillSvg,
  film: FilmSvg,
  'film-fill': FilmFillSvg,
  play: PlaySquareSvg,
  'play-square': PlaySquareSvg,
  shareplay: ShareplaySvg,
  'music-tv': MusicNoteTvSvg,
  'music.note.tv': MusicNoteTvSvg, // alias
  'music-tv-fill': MusicNoteTvFillSvg,
  'music.note.tv.fill': MusicNoteTvFillSvg, // alias
  'music-house': MusicNoteHouseSvg,

  // Notifications
  bell: BellSvg,
  'bell-badge': BellBadgeSvg,

  // Settings/Actions
  settings: GearSvg,
  gear: GearSvg,
  plus: PlusSvg,
  ellipsis: EllipsisSvg,
  'ellipsis-vertical': EllipsisVerticalSvg,
  checkmark: CheckmarkSvg,
  logout: LogoutSvg,
  appearance: AppearanceSvg,
  translate: TranslateSvg,

  // Interactions
  'thumbs-up': ThumbsUpSvg,
  'hand.thumbsup': ThumbsUpSvg, // alias
  'thumbs-up-fill': ThumbsUpFillSvg,
  'hand.thumbsup.fill': ThumbsUpFillSvg, // alias
  'thumbs-down': ThumbsDownSvg,
  'hand.thumbsdown': ThumbsDownSvg, // alias
  'thumbs-down-fill': ThumbsDownFillSvg,
  'hand.thumbsdown.fill': ThumbsDownFillSvg, // alias

  // Upload/Share
  upload: SquareArrowUpSvg,
  'square.and.arrow.up': SquareArrowUpSvg, // alias
  'upload-fill': SquareArrowUpFillSvg,
  'square.and.arrow.up.fill': SquareArrowUpFillSvg, // alias
  share: SquareArrowUpSvg,
  edit: SquarePencilSvg,
  'edit-pencil': RectanglePencilSvg,

  // Analytics/Stats
  chart: ChartPieSvg,
  'chart-fill': ChartPieFillSvg,
  trophy: TrophySvg,
  'trophy-fill': TrophyFillSvg,

  // Content
  document: RichtextPageSvg,
  'document-fill': RichtextPageFillSvg,
  terminal: TerminalSvg,
  'terminal-fill': TerminalFillSvg,

  // Utility
  history: ClockRotateSvg,
  'clock-rotate': ClockRotateSvg,
  slider: SliderHorizontalSvg,
}

/**
 * Icon Component - Centralized icon management
 *
 * @param {string} name - Icon name from the registry
 * @param {number} size - Icon size in pixels (default: 24)
 * @param {string} color - Icon color (default: currentColor)
 * @param {string} className - Additional CSS classes
 * @param {object} props - Additional props passed to the icon
 *
 * @example
 * <Icon name="home" size={24} />
 * <Icon name="person-fill" size={32} color="#ff0000" />
 * <Icon name="video" className="custom-class" />
 */
const Icon = ({
  name,
  size = 24,
  color = 'currentColor',
  className = '',
  style = {},
  ...props
}) => {
  const IconComponent = icons[name]

  if (!IconComponent) {
    console.warn(`Icon "${name}" not found in IconLibrary`)
    return null
  }

  const iconStyle = {
    width: size,
    height: size,
    color: color,
    display: 'inline-block',
    flexShrink: 0,
    ...style,
  }

  return (
    <span
      className={`icon icon-${name} ${className}`}
      style={iconStyle}
      {...props}
    >
      <IconComponent
        width={size}
        height={size}
        style={{ display: 'block' }}
      />
    </span>
  )
}

// Export individual icons for direct use if needed
export {
  HouseSvg,
  HouseFillSvg,
  PersonSvg,
  PersonFillSvg,
  VideoSvg,
  VideoFillSvg,
  // ... add more as needed
}

// Export the registry for reference
export { icons }

// Default export is the Icon component
export default Icon
